import React, { Fragment, useEffect, useState } from 'react'
import Img from 'gatsby-image'

//components
import Layout from '../../components/Layout/'
import SEO from '../../components/Seo/'
import OpenVideo from '../../components/OpenVideo'
import Footer from '../../components/Footer'
import WhatchNow from '../../images/whatch-now.png'
import Icon from '../../components/Icon'
import Header from '../../components/Header'
import ScrollTo from '../../components/ScrollTo'

// Data
import PageEN from './assets/data/dataEN.json'
import PageES from './assets/data/dataES.json'
import PagePT from './assets/data/dataPT.json'

// Styles
import { SimplifiesSection, ButtonLink, Video, ScrollLink } from "./style"

// Types
import { AboutInterProps } from '../../types/types'

// Images Query
import usePageQuery from './pageQuery'

const AboutUs = () => {
  const data = usePageQuery()
  const [ content, setContent ] = useState<AboutInterProps[]>([])
  const [ typeLanguage, setTypeLanguage ] = useState('EN')
  const [ seoTitle, setSeoTitle ] = useState('')

  useEffect(() => {
    switch(typeLanguage) {
      case 'EN':
        setContent(PageEN)
        setSeoTitle('You can call me Inter.')
        break
      case 'ES':
        setContent(PageES)
        setSeoTitle('Puedes llamarme Inter')
        break
      case 'PT':
        setContent(PagePT)
        setSeoTitle('Pode me chamar de Inter')
        break
    }
  }, [ typeLanguage ])

  return (
    <Layout >
      <SEO title={seoTitle} />
      <Header typeLanguage={typeLanguage} setTypeLanguage={setTypeLanguage} />
      {content.map((item: AboutInterProps, index: number) => (
        <Fragment key={index}>
          <SimplifiesSection className='py-2 py-md-4 py-xl-5'>
            <div className='container'>
              <div className='row'>
                <div className='col-12 col-lg-6 mt-5 mt-lg-0 pt-5 pt-lg-0'>
                  <h2 className='fs-30 fs-md-48 lh-60 text-white fw-600' dangerouslySetInnerHTML={{ __html: item.titleHeader }} />
                  <p className='fs-18 lh-22 text-white mt-3' dangerouslySetInnerHTML={{ __html: item.firstParagraphHeader }} />
                  <p className='fs-18 lh-22 text-white' dangerouslySetInnerHTML={{ __html: item.secondParagraphHeader }} />
                </div>
              </div>
            </div>
            <ScrollTo to='#hello' styles='scroll-link text-center d-none d-md-block'>
              <ScrollLink className='pb-md-4'>
                <p className='text-white mb-0 fs-14 fs-lg-16 fw-600' dangerouslySetInnerHTML={{ __html: item.chevronHeader }} />
                <Icon color='white' width='24' height='24' icon='navigation/chevron-down' directory='v2' />
              </ScrollLink>
            </ScrollTo>
          </SimplifiesSection>
          <section id='hello'>
            <div className='container py-5'>
              <div className='row align-items-center py-md-5'>
                <div className='col-12 col-md-6 col-lg-5'>
                  <Img fluid={data.Hello.fluid} alt={item.titleSalutation} />
                </div>
                <div className='col-12 col-md-6 col-lg-6 col-xl-5 offset-lg-1 offset-xl-2 mt-4 mt-md-0'>
                  <h2 className='fs-24 fs-md-40 lh-50 text-blue-900 fw-600' dangerouslySetInnerHTML={{ __html: item.titleSalutation }} />
                  <p className='fs-18 lh-22 text-gray-200 mt-3' dangerouslySetInnerHTML={{ __html: item.firstParagraphSalutation }} />
                  <p className='fs-18 lh-22 text-gray-200' dangerouslySetInnerHTML={{ __html: item.secondParagraphSalutation }} />
                  <p className='fs-18 lh-22 text-gray-200' dangerouslySetInnerHTML={{ __html: item.thirdParagraphSalutation }}/>
                  <p className='fs-18 lh-22 text-gray-200' dangerouslySetInnerHTML={{ __html: item.fourthParagraphSalutation }} />
                  <ButtonLink
                    className='btn btn-lg bg-orange-medium text-white fs-14 lh-17 w-100 fw-600 mt-3'
                    href={item.urlButton} target='_blank' title={item.buttonSalutation}
                    dangerouslySetInnerHTML={{ __html: item.buttonSalutation }} />
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className='container'>
              <div className='row align-items-center'>
                <div className='col-12 col-md-6'>
                  <h2 className='fs-24 fs-md-40 lh-50 text-blue-900 fw-600' dangerouslySetInnerHTML={{ __html: item.titleThinking}} />
                  <p className='fs-18 lh-22 text-gray-200 mt-3' dangerouslySetInnerHTML={{ __html: item.firstParagraphThinking}} />
                </div>
                <div className='col-12 col-md-6 col-lg-5 offset-lg-1 mt-2 mt-md-0'>
                  <Video>
                    <Img fluid={data.VideoBG.fluid} alt='Smiling girl' />
                    <div className='player'>
                      <OpenVideo linkIframe='https://www.youtube-nocookie.com/embed/CUQNrmTvrDw'>
                        <img src={WhatchNow} alt={item.videoTagAltThinking} />
                      </OpenVideo>
                    </div>
                  </Video>
                </div>
              </div>
            </div>
          </section>
        </Fragment>
       ))}
      <Footer typeLanguage={typeLanguage}/>
    </Layout>
  )
}

export default AboutUs
